import type { NexusSignal } from "../../exports/nexus";
import type { AsyncNamespace } from "../nexus/namespace/namespace.types";
import * as screen from "./async/screen.js";
import { detectOS, OsType } from "./async/detectOS.js";
import { Browser, detectBrowser } from "./async/browser.js";
import { detectType, DeviceType } from "./async/type.js";

declare global {
  interface NexusInterfaces {
    /**
 *
 */
    device: AsyncNamespace<DeviceAsync>;
  }
}

export type DeviceScreenSpecs = {
  /**
 *
 */
  width: number;
  /**
 *
 */
  height: number;
  /**
 *
 */
  pixelRatio: number;
};

export type DevicePointerType = {
  /**
 *
 */
  isTouchable: boolean;
  /**
 *
 */
  isHybrid: boolean;
};

export interface DeviceAsync {
  /**
 *
 *
 */
  pointerType: NexusSignal<DevicePointerType | undefined>;

  /**
 *
 */
  getPointerType: typeof getPointerType;

  /**
 *
 */
  getScreenSpecs: typeof getScreenSpecs;
}

export * from "./async/browser.js";
export * from "./async/events.js";
export * from "./async/hybrid.js";
export * from "./async/orientation.js";
export * from "./async/detectOS.js";
export * as screen from "./async/screen.js";
export * from "./async/touch.js";
export * from "./async/type.js";

/**
 *
 */
export type GlobalDevice = {
  os: `${OsType}`;
  browser: `${Browser}`;
  type: `${DeviceType}`;
};

/**
 *
 *
 */
export const os = detectOS();

/**
 *
 *
 */
export const browser = detectBrowser();

/**
 *
 *
 */
export const type = detectType();

/**
 *
 *
 *
 *
 */
export const getPointerType = (): DevicePointerType =>
  otto.device.pointerType.get() ?? { isTouchable: false, isHybrid: false };

/**
 *
 *
 *
 *
 */
export const getScreenSpecs = (): DeviceScreenSpecs => ({
  width: screen.getWidth(),
  height: screen.getHeight(),
  pixelRatio: screen.getDevicePixelRatio(),
});
